import { detect } from 'detect-browser';


/**
 * Parsed user agent information
 */
export interface UserAgent {
  /**
   * Normalized browser name (e.g., 'chrome', 'ie', 'firefox')
   */
  name: string;

  /**
   * Browser version. Note this may be a version number in semver format (e.g., "65.0.3325.181"). Use semver-compare
   * to compare version numbers.
   */
  version: string;

  /**
   * Normalized operation system name (e.g., 'Windows 10', 'Mac OS', 'Linux', 'iOS', 'Android OS', etc.)
   */
  os: string;
}


/**
 * Information about the user's browser (if available). If browser detection fails, this will be null.
 */
export const browser: UserAgent = detect() as UserAgent || null;
